import React from 'react';
import { ChevronDown } from 'lucide-react';

const MONTHS = [
  { value: '01', label: 'January' },
  { value: '02', label: 'February' },
  { value: '03', label: 'March' },
  { value: '04', label: 'April' },
  { value: '05', label: 'May' },
  { value: '06', label: 'June' },
  { value: '07', label: 'July' },
  { value: '08', label: 'August' },
  { value: '09', label: 'September' },
  { value: '10', label: 'October' },
  { value: '11', label: 'November' },
  { value: '12', label: 'December' },
];

const currentYear = new Date().getFullYear();
const YEARS = Array.from({ length: 50 }, (_, i) => currentYear - i); // Up to 50 years back

const MonthYearPicker = ({ value, onChange, disabled }) => {
  const [year, month] = String(value || '').split('-');

  const handleMonthChange = (e) => {
    const newMonth = e.target.value;
    onChange(newMonth ? `${year || currentYear}-${newMonth}` : '');
  };

  const handleYearChange = (e) => {
    const newYear = e.target.value;
    onChange(newYear ? `${newYear}-${month || '01'}` : '');
  };

  return (
    <div className="flex gap-2">
      <div className="relative w-1/2">
        <select 
          value={month || ''} 
          onChange={handleMonthChange}
          disabled={disabled}
          className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-1 focus:ring-blue-500 focus:outline-none disabled:bg-gray-100 disabled:text-gray-400 appearance-none bg-white pr-8 cursor-pointer"
        >
          <option value="" disabled>Month</option>
          {MONTHS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
        </select>
        <ChevronDown size={14} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
      </div>
      
      <div className="relative w-1/2">
        <select 
          value={year || ''} 
          onChange={handleYearChange}
          disabled={disabled}
          className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring-1 focus:ring-blue-500 focus:outline-none disabled:bg-gray-100 disabled:text-gray-400 appearance-none bg-white pr-8 cursor-pointer"
        >
          <option value="" disabled>Year</option>
          {YEARS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <ChevronDown size={14} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
      </div>
    </div>
  );
};

export default MonthYearPicker;
